import { ReactNode } from 'react';
import type { CompletionFragment } from '../planner/manage/planner.graphql.generated';
import { COMPLETION_STATUS_COMPLETED } from 'global/constants';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import { useAuthorisedAction } from 'approot/shared/hooks/authorised-action.hooks';
import { ButtonRadioSecondary } from 'approot/shared/styles/buttons/buttons';
import Complete from './complete';
import Incomplete from './incomplete';

type RenderButtonProps = {
  onClick: () => void;
  isComplete: boolean;
};

type Props = {
  contentId: number;
  contentName: string;
  unitId: number;
  isLesson: boolean;
  isInPlanner: boolean;
  completion: CompletionFragment | null;
  renderButton?: (props: RenderButtonProps) => ReactNode;
};

const CompleteModalButton = ({
  contentId,
  contentName,
  unitId,
  isLesson,
  isInPlanner,
  completion,
  renderButton,
}: Props) => {
  const { authoriseActiveTeacher } = useAuthorisedAction();

  const {
    isVisible: isCompleteVisible,
    openModal: openCompleteModal,
    closeModal: closeCompleteModal,
  } = useSimpleModalState();

  const {
    isVisible: isIncompleteVisible,
    openModal: openIncompleteModal,
    closeModal: closeIncompleteModal,
  } = useSimpleModalState();

  const isComplete = completion?.status === COMPLETION_STATUS_COMPLETED;

  const handleClick = isComplete
    ? () => authoriseActiveTeacher(openIncompleteModal)
    : () => authoriseActiveTeacher(openCompleteModal);

  return (
    <>
      {isCompleteVisible && (
        <Complete
          contentId={contentId}
          unitId={unitId}
          isLesson={isLesson}
          isInPlanner={isInPlanner}
          closeModal={closeCompleteModal}
        />
      )}
      {isIncompleteVisible && (
        <Incomplete
          contentId={contentId}
          contentName={contentName}
          unitId={unitId}
          completion={completion}
          isLesson={isLesson}
          isInPlanner={isInPlanner}
          closeModal={closeIncompleteModal}
        />
      )}
      {renderButton ? (
        renderButton({ onClick: handleClick, isComplete })
      ) : (
        <ButtonRadioSecondary
          isActive={isComplete}
          label="Complete"
          data-selector={isComplete ? 'is-completed' : 'mark-complete'}
          onClick={handleClick}
        />
      )}
    </>
  );
};

export default CompleteModalButton;
